
import PaperCard from "../components/common/PaperCard";
import PocketBase from 'pocketbase';
import React, { useEffect, useState } from "react";
import { Typography, CircularProgress } from "@mui/material";
import { useParams } from "react-router-dom";

const pb = new PocketBase(process.env.REACT_APP_POCKETBASE_URL);

export default function OLPastPapers() {
    const [papers, setPapers] = useState([]);
    const [filterType, setFilterType] = useState("paper");
    const [loading, setLoading] = useState(true);
    const { folderId } = useParams();

    useEffect(() => {
        const fetchPapers = async () => {
            try {
                const resultList = await pb.collection('OL').getList(1, 500, {
                    filter: `folder = "${folderId}"`,
                });;
                setPapers(resultList.items);
            } catch (error) {
                console.error("Error fetching papers:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchPapers();
    },[folderId]);

    const filteredPapers = papers.filter(paper => paper.type.toLowerCase() === filterType);

    return (
        <div className="flex flex-col justify-center items-center">
            <Typography variant="h3" sx={{ 
                mb: 4,
                textAlign: "center",
                fontWeight: 700,
                color: "text.primary",
                letterSpacing: "-0.05rem",
                marginTop: "20px",
                "&:after": {
                    content: '""',
                    display: "block",
                    width: "60px",
                    height: "4px",
                    backgroundColor: "primary.main",
                    margin: "8px auto 0",
                }
            }}>
                O/L Api
            </Typography>
            <div className="mb-5 flex justify-center w-full">
                <select
                    value={filterType}
                    onChange={(e) => setFilterType(e.target.value)}
                    className="block w-2/3 p-2 border border-gray-300 rounded-md shadow-sm bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition ease-in-out"
                >
                    <option value="paper">Paper</option>
                    <option value="note">Notes</option>
                </select>
            </div>
            {loading ? (
                <div className="flex justify-center items-center" style={{ minHeight: "200px" }}>
                    <CircularProgress />
                </div>
            ) : (
                <>
                    {filteredPapers.length === 0 ? (
                        <Typography variant="body1" sx={{ mt: 2 }}>
                            No items found.
                        </Typography>
                    ) : (
                        filteredPapers.map((paper) => (
                            <PaperCard paper={paper} key={paper.id}/>
                        ))
                    )}
                </>
            )}
        </div>
    );
}
